<template>
  <div class="charge-detail">
    <div class="main">
      <div class="list">
        <div class="name-label">设备编号：</div>
        <div class="value-label">{{ deviceInfo.primaryDeviceNo }}</div>
        <div class="name-label">设备二维码：</div>
        <div class="value-label" style="width: 4%">{{ deviceInfo.qrcodeBindStatus == 1 ? '已绑定' : '未绑定' }}</div>
        <el-upload
          class="value-label"
          action=""
          accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="bindQrcode">
          <div class="value-label ml10" style="color: #67aa42;width: 100%">
            {{ deviceInfo.qrcodeBindStatus == 1 ? '更换二维码' : '绑定二维码' }}
          </div>
        </el-upload>
        <div class="name-label">通讯板编号：</div>
        <div class="value-label">{{ deviceInfo.communicationBoardNo }}</div>
        <div class="name-label">设备类型：</div>
        <div class="value-label">{{ deviceInfo.type }}</div>
      </div>
      <div class="list">
        <div class="name-label">定位地址：</div>
        <div class="value-label" style="width: 43%">{{ deviceInfo.location }}</div>
        <div class="name-label">投放地址：</div>
        <div class="value-label" style="width: 43%">{{ deviceInfo.showPlacingPosition }}</div>
      </div>
      <div class="list">
        <div class="blue-btn" @click="onQueryBtnClick(deviceInfo.primaryDeviceNo)">查看设备快照</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>端口编号</th>
          <th>端口二维码状态</th>
          <th>端口状态</th>
          <th>端口电流</th>
          <th>端口电压</th>
          <th>端口已充电量</th>
          <th>充电时长</th>
          <th>更新时间</th>
          <th width="280px">操作</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.chargePortSeqNo }}</td>
          <td>{{ item.qrcodeBindStatus == 1 ? "已绑定" : "未绑定" }}</td>
          <td>{{ item.status }}</td>
          <td>{{ item.electricCurrent }}</td>
          <td>{{ item.electricVoltage }}</td>
          <td>{{ item.electricityCostDegree }}</td>
          <td>{{ item.chargeTimeLength }}</td>
          <td>{{ item.updateTime }}</td>
          <td>
            <el-upload
              class="text-btn fixed-width-120"
              action=""
              accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="bindQrcode2">
              <div class="text-btn fixed-width-120" @mouseover="chooseChargePort(item)">
                {{ item.qrcodeBindStatus == 1 ? '更换端口二维码' : '绑定端口二维码' }}
              </div>
            </el-upload>
            <div class="text-btn fixed-width-60" @click="onPowerOnBtnClick(item)">通电</div>
            <div class="text-btn fixed-width-60" @click="onPowerOffBtnClick(item)">断电</div>
          </td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="9">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'chargeMgmtDetailView',
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      deviceInfo: {},
      primaryDeviceNo: '',
      qrCode: '',
      dataList: []
    }
  },
  watch: {
    editData: {
      handler() {
        this.primaryDeviceNo = this.editData.primaryDeviceNo;
        this.queryChargeDetail()
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    queryChargeDetail() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo
      };
      this.$http.post('/managementPlatform/electricity/wholeDeviceInfo', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.mdata.deviceInfo.chargePortList;
        self.deviceInfo = res.mdata.deviceInfo;
      }).catch(function (response) {
        console.log(response);
      });
    },
    cancelHandle() {
      this.view = 'list';
    },
    bindQrcode(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        this.qrCode = Utils.getQueryParam(res.data, 'qrcode');
        this.bindQrCodeToDevice();
      });
    },
    bindQrCodeToDevice() {
      let self = this;
      let params = {
        cabinetNo: this.deviceInfo.primaryDeviceNo,
        qrcode: this.qrCode,
        reconfirm: 0
      };
      this.$http.post('/managementPlatform/electricity/bindQRCode', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        if (res.mdata.needReconfirm == 1) {
          self.$confirm(res.mdata.msg, '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.reconfirm = 1;
            self.bindQrCodeToDevice();
          }).catch(action => {
          });
        } else {
          self.$message({
            type: "success",
            message: "绑定成功!",
            center: true
          });
          self.deviceInfo.qrcodeBindStatus = '1';
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    chooseChargePort(item) {
      this.chargePortNo = item.chargePortNo;
    },
    bindQrcode2(file) {
      let url = URL.createObjectURL(file.raw);
      this.$qrcode.decodeFromImage(url).then((res) => {
        this.qrCode = Utils.getQueryParam(res.data, 'qrcode');
        this.bindQrCodeToChargePort();
      });
    },
    bindQrCodeToChargePort() {
      let self = this;
      let params = {
        chargePortNo: this.chargePortNo,
        qrcode: this.qrCode,
        reconfirm: 0
      };
      this.$http.post('/managementPlatform/electricity/bindQRCode', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        if (res.mdata.needReconfirm == 1) {
          self.$confirm(res.mdata.msg, '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.reconfirm = 1;
            self.bindQrCodeToChargePort();
          }).catch(action => {
          });
        } else {
          self.$message({
            type: "success",
            message: "绑定成功!",
            center: true
          });
          self.deviceInfo.qrcodeBindStatus = '1';
        }
      }).catch(function (response) {
        console.log(response);
      });
    },
    onQueryBtnClick(data) {
      let searchCondition = this.editData.searchCondition;
      this.$router.push("/managePage/snapShot?primaryDeviceNo=" + data + "&type=1&searchCondition=" + searchCondition.searchCondition + "&deviceName=" + searchCondition.deviceName + "&beginIndex=" + searchCondition.beginIndex);
    },
    onPowerOnBtnClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 1;
      let self = this;
      this.$confirm('是否确定通电?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateChargePort(chargePortNo, operate);
      }).catch(action => {
      });
    },
    onPowerOffBtnClick(data) {
      let chargePortNo = data.chargePortNo;
      let operate = 2;
      let self = this;
      this.$confirm('是否确定断电?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.operateChargePort(chargePortNo, operate);
      }).catch(action => {
      });
    },
    operateChargePort(chargePortNo, operate) {
      let self = this;
      let params = {
        chargePortNo: chargePortNo,
        operate: operate
      }
      this.$http.post('/managementPlatform/electricity/operate', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "操作成功!",
          center: true
        });
      }).catch(function (response) {
        console.log(response);
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/chargeMgmtDetailView.vue